import { Pipe, PipeTransform } from '@angular/core';
import { PermissionService } from '../services/permission.service';

@Pipe({
  name: 'roleCheck'
})
export class RoleCheckPipe implements PipeTransform {

  constructor(private permissionService:PermissionService){}

  transform(roles: any): boolean {
    return this.permissionService.checkRole(roles);
  }

}
